import univr from '../assets/logo/logoUniversita.png';
import lugagnanoCalcio from '../assets/landing/marquee/Lugagnano.png';
import casteldazzanoCalcio from '../assets/landing/marquee/CastelDazzano.png';

const partners = [
    { src: univr, alt: 'Università di Verona', name: "Università Degli Studi di Verona" },
    { src: lugagnanoCalcio, alt: 'Lugagnano Calcio', name: "U.C. Lugagnano Calcio" },
    { src: casteldazzanoCalcio, alt: 'Casteldazzano Calcio', name: "U.S.D. Castel D'Azzano" },
];

const logos = Array.from({ length: 3 }, () => partners).flat();

export default function LogosMarquee() {
    return (
        <div className='py-10' data-aos="fade-in" data-aos-duration="1000">
            <h2 className="text-white text-3xl font-bold text-center mb-8">Collaboriamo con</h2>

            <div className="relative w-full overflow-hidden">
                <div className="flex w-max gap-20 md:gap-40 animate-marquee">
                    {/* LOGOS ANIMATON */}
                    {[...logos, ...logos].map((logo, index) => (
                        <div
                            key={index}
                            className="flex flex-col gap-4 items-center justify-center shrink-0">
                            <img src={logo.src} alt={logo.alt} className="h-24  object-contain" />
                            <p className="uppercase text-white text-center text-xs font-semibold">{logo.name}</p>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}
